import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRotateLeft, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { faLoader } from '@fortawesome/pro-regular-svg-icons'
import { useTheme } from '@mui/material/styles'

interface IconButtonProps {
  onClick: () => void
  isLoading: boolean
  allLoading: boolean
}

export const LoadingSpinnerButton: React.FC<IconButtonProps> = ({
  onClick,
  isLoading,
  allLoading,
}) => {
  const theme = useTheme()
  const iconColor = theme.palette.select.light

  return (
    <div
      style={{ cursor: 'pointer' }}
      onClick={isLoading ? undefined : onClick}
    >
      {isLoading || allLoading ? (
        <FontAwesomeIcon
          icon={faLoader}
          spin
          width={14}
          height={14}
          color={iconColor}
        />
      ) : (
        <FontAwesomeIcon
          icon={faRotateLeft}
          width={14}
          height={14}
          color={iconColor}
        />
      )}
    </div>
  )
}
